/**
 * P3-31: Faith 计数文本（原 religion.js:3109-3110 faithCount span）。
 */
import { useGameTick } from "../../bridge/useGameTick";
import type { GamePage } from "../../bridge/GameBridge";

export function FaithCounter() {
  const text = useGameTick((game: GamePage | null): string => {
    if (!game) {return "";}
    const religion = game.religion as {
      faith?: number;
      faithRatio?: number;
      getRU?: (name: string) => { researched?: boolean } | null;
    };
    const faith = religion.faith ?? 0;
    if (!faith) {
      return "";
    }
    const ratio = religion.faithRatio ?? 0;
    const solar = religion.getRU?.("solarRevolution")?.researched;
    let s = game.getDisplayValueExt(faith);
    if (solar && ratio > 0) {
      s += " (" + game.getDisplayValueExt(ratio * 100) + "%)";
    }
    return s;
  });

  return (
    <span style={{ display: "inline-block", marginBottom: "10px" }} dangerouslySetInnerHTML={{ __html: text }} />
  );
}
